import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { authApi, getToken, setToken, clearToken, activityApi, User } from "./api";

interface AuthCtx {
  user: User | undefined | null; // undefined = memeriksa, null = belum login
  login: (email: string, password: string) => Promise<void>;
  register: (email: string, password: string, name: string) => Promise<void>;
  logout: () => void;
}

const Ctx = createContext<AuthCtx>(null as any);
export const useAuth = () => useContext(Ctx);

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const [user, setUser] = useState<User | undefined | null>(undefined);

  useEffect(() => {
    if (!getToken()) { setUser(null); return; }
    authApi.me().then(setUser).catch(() => { clearToken(); setUser(null); });
  }, []);

  const login = useCallback(async (email: string, password: string) => {
    const res = await authApi.login(email, password);
    setToken(res.access_token);
    setUser(res.user);
    activityApi.log({ action: "login" });
  }, []);

  const register = useCallback(async (email: string, password: string, name: string) => {
    const res = await authApi.register(email, password, name);
    setToken(res.access_token);
    setUser(res.user);
    activityApi.log({ action: "login", meta: { baru: true } });
  }, []);

  const logout = useCallback(() => {
    activityApi.log({ action: "logout" });
    clearToken();
    setUser(null);
  }, []);

  return <Ctx.Provider value={{ user, login, register, logout }}>{children}</Ctx.Provider>;
}
